import { render, staticRenderFns } from "./CreditBookForm.vue?vue&type=template&id=68b2722b&scoped=true"
import script from "./CreditBookForm.vue?vue&type=script&lang=js"
export * from "./CreditBookForm.vue?vue&type=script&lang=js"
import style0 from "./CreditBookForm.vue?vue&type=style&index=0&id=68b2722b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b2722b",
  null
  
)

export default component.exports